const QUERY_KEYS = {
  Dealer: 'dealer',
  Dealers: 'dealers',
  DealerLocations: 'dealerLocations',
  Event: 'event',
  Events: 'events',
  Schedule: 'schedule',
  Profile: 'profile',
  Coupon: 'coupon',
  SupporterStatus: 'supporterStatus',
  Status: 'status',

  EventInstances: 'eventInstances',

  Friends: {
    Visibility: 'friendsVisibility',
    Active: 'activeFriends',
    Count: 'friendCount',
  } as const,

  Party: {
    Party: 'currentParty',
  },

  PrivateParty: {
    Squad: ['party-host', 'squad'],
    ValidTargets: ['party-host', 'valid-targets'],
    GuestParties: 'privateGuestParties',
  } as const,

  VrchatWorldLink: 'vrchatWorldLink',

  VoucherRequests: {
    Applied: 'voucherRequest:applied',
  },

  Auction: {
    Item: 'auction:item',
    Items: 'auction:items',
    Bids: 'auction:bids',
  },
} as const;

export default QUERY_KEYS;
